import { getDefaultCurrency } from 'store/state';

export interface IFormatCurrecyOptions {
  suffix?: string;
  fractionDigits?: number;
  length?: number;
  minimumFractionDigits?: number;
}

export const formatCurrency = (number = 0, options?: IFormatCurrecyOptions) => {
  const currency = number
    .toLocaleString('en-US', {
      minimumFractionDigits:
        options?.minimumFractionDigits ?? options?.fractionDigits ?? 2,
      maximumFractionDigits: options?.fractionDigits ?? 2,
    })
    .replaceAll(',', ' ')
    .replace('.', ',')
    .concat(
      ` ${options?.suffix?.trim() ?? getDefaultCurrency()?.currencyCode ?? ''}`
    );

  if (options?.length && currency.length < options.length) {
    const missingSpaces = options.length - currency.length;
    return `${'  '.repeat(missingSpaces)}${currency}`;
  }

  return currency;
};

export const formatCurrencyFull = (number = 0) => {
  const formatted = number
    .toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 20,
    })
    .replaceAll(',', ' ')
    .replace('.', ',');

  return `${formatted} ${getDefaultCurrency()?.currencyCode ?? ''}`;
};
